import React, { useState, useEffect } from 'react';
import { FaUsers, FaProjectDiagram, FaFileAlt, FaStore, FaUserTie, FaFileInvoiceDollar, FaChevronLeft, FaChevronRight, FaBell, FaUser, FaTimes, FaCheckCircle, FaExclamationCircle, FaInfoCircle, FaClipboardList, FaUserEdit, FaClipboardCheck } from 'react-icons/fa';
import './Home.css';

const Home = ({ onCardClick, currentUser }) => {
  const [transitioning, setTransitioning] = useState(false);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [showProfileMenu, setShowProfileMenu] = useState(false);
  const [showNotifications, setShowNotifications] = useState(false);
  const [showProfileModal, setShowProfileModal] = useState(false);
  const [profileImage, setProfileImage] = useState(null);
  const [userName, setUserName] = useState("User Name");
  const [userEmail, setUserEmail] = useState("");
  const [userRole, setUserRole] = useState("");
  const [notifications, setNotifications] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);
  const [filterType, setFilterType] = useState('all');

  const carouselImages = [
    'https://i.ibb.co/1GV86m2y/Gemini-Generated-Image-cqj50acqj50acqj5.png',
    'https://i.ibb.co/pvQNPBMm/Gemini-Generated-Image-ojaypiojaypiojay.png',
    'https://i.ibb.co/RGR4GkPM/Gemini-Generated-Image-geupx1geupx1geup.png',
    'https://i.ibb.co/Y7RBchhC/Gemini-Generated-Image-gl95l9gl95l9gl95.png'
  ];

  const getUserRole = () => {
    const userType = localStorage.getItem('userType');
    if (userType === 'client') {
      return 'CLIENT';
    }

    const storedUser = localStorage.getItem('currentUser');
    const storedRole = localStorage.getItem('currentUserRole');
    const accessLevel = localStorage.getItem('accessLevel');
    
    let userRole = storedRole;
    
    if (storedUser) {
      try {
        const userData = JSON.parse(storedUser);
        userRole = userData.role || storedRole;
      } catch (error) {
      
      }
    }
    
    if (accessLevel === 'full' || 
        userRole?.toUpperCase() === 'CEO' || 
        userRole?.toUpperCase().includes('CEO') ||
        userRole?.toUpperCase() === 'ADMIN' ||
        userRole?.toUpperCase().includes('ADMIN') ||
        userRole?.toUpperCase().includes('ASSISTANT ADMIN')) {
      return 'CEO';
    } else {
      return 'EMPLOYEE';
    }
  };

  const allCards = [
    { id: 'employees', text: 'Employees', Icon: FaUsers, visibleFor: ['CEO', 'EMPLOYEE'] },
    { id: 'projects', text: 'Projects', Icon: FaProjectDiagram, visibleFor: ['CEO', 'EMPLOYEE'] },
    { id: 'reports', text: 'Reports', Icon: FaFileAlt, visibleFor: ['CEO', 'EMPLOYEE'] },
    { id: 'vendors', text: 'Vendors', Icon: FaStore, visibleFor: ['CEO'] },
    { id: 'clients', text: 'Clients', Icon: FaUserTie, visibleFor: ['CEO'] },
    { id: 'taxInvoices', text: 'Tax Invoices', Icon: FaFileInvoiceDollar, visibleFor: ['CEO'] },
    { id: 'performaInvoices', text: 'Performa Invoices', Icon: FaFileInvoiceDollar, visibleFor: ['CEO'] },
    { id: 'reportSubmission', text: 'Report Submission', Icon: FaClipboardCheck, visibleFor: ['CEO', 'CLIENT'] },
  ];

  const role = getUserRole();
  const visibleCards = allCards.filter(card => card.visibleFor.includes(role));

  

  const loadNotifications = () => {
    const currentUserId = localStorage.getItem('currentUserId');
    if (!currentUserId) return;
    
    const storedNotifications = localStorage.getItem(`notifications_${currentUserId}`) || '[]';
    
    try {
      const parsedNotifications = JSON.parse(storedNotifications);
      const sortedNotifications = parsedNotifications.sort((a, b) => 
        new Date(b.timestamp) - new Date(a.timestamp)
      );
      setNotifications(sortedNotifications);
      
      const unread = sortedNotifications.filter(n => !n.read).length;
      setUnreadCount(unread);
    } catch (error) {
     
      setNotifications([]);
    }
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % carouselImages.length);
    }, 3000);

    return () => clearInterval(interval);
  }, [carouselImages.length]);

  useEffect(() => {
    const storedUser = localStorage.getItem('currentUser');
    const storedProfileImage = localStorage.getItem('currentUserProfileImage');
    const storedUserName = localStorage.getItem('currentUserName');
    const storedUserEmail = localStorage.getItem('currentUserEmail');
    const storedUserRole = localStorage.getItem('currentUserRole');
    
    if (storedUser) {
      try {
        const userData = JSON.parse(storedUser);
        setUserName(userData.name || storedUserName || "User Name");
        setUserEmail(userData.email || storedUserEmail || "");
        setUserRole(userData.role || storedUserRole || "Client");
        
        if (userData.id || userData.employee_id || userData.client_id) {
          const userId = userData.id || userData.employee_id || userData.client_id;
          const userImage = localStorage.getItem(`employee_${userId}_profileImage`) || 
                           localStorage.getItem(`client_${userId}_profileImage`);
          if (userImage) {
            setProfileImage(userImage);
          }
        }
      } catch (error) {
        
        setUserName(storedUserName || "User Name");
        setUserEmail(storedUserEmail || "");
        setUserRole(storedUserRole || "Client");
      }
    }
    
    if (storedProfileImage) {
      setProfileImage(storedProfileImage);
    }
    
    if (storedUserName) {
      setUserName(storedUserName);
    }
    
    if (storedUserEmail) {
      setUserEmail(storedUserEmail);
    }
    
    if (storedUserRole) {
      setUserRole(storedUserRole);
    }

    loadNotifications();

    const handleNotificationUpdate = () => {
      loadNotifications();
    };

    const handleStorageChange = (e) => {
      if (e.key && (e.key.startsWith('notifications_') || e.key === 'notifications_update')) {
        loadNotifications();
      }
    };

    window.addEventListener('storage', handleStorageChange);
    window.addEventListener('notificationUpdate', handleNotificationUpdate);

    const notificationCheckInterval = setInterval(loadNotifications, 5000);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
      window.removeEventListener('notificationUpdate', handleNotificationUpdate);
      clearInterval(notificationCheckInterval);
    };
  }, []);

  const handleCardClick = (cardId) => {
    if (transitioning) return;
    setTransitioning(true);
    onCardClick(cardId);
  };

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  const goToPrevious = () => {
    setCurrentSlide((prev) => (prev - 1 + carouselImages.length) % carouselImages.length);
  };

  const goToNext = () => {
    setCurrentSlide((prev) => (prev + 1) % carouselImages.length);
  };

  const handleViewProfile = () => {
    setShowProfileMenu(false);
    setShowProfileModal(true);
  };

  const handleLogout = () => {
    localStorage.removeItem('currentUser');
    localStorage.removeItem('currentUserEmail');
    localStorage.removeItem('currentUserName');
    localStorage.removeItem('currentUserId');
    localStorage.removeItem('currentUserProfileImage');
    localStorage.removeItem('authToken');
    localStorage.removeItem('currentUserRole');
    localStorage.removeItem('accessLevel');
    localStorage.removeItem('allEmployeesData');
    localStorage.removeItem('userType');
    localStorage.removeItem('currentClientId');
    
    window.location.reload();
  };

  const handleMarkAllRead = (e) => {
    e.stopPropagation();
    const currentUserId = localStorage.getItem('currentUserId');
    const updatedNotifications = notifications.map(notif => ({ ...notif, read: true }));
    
    localStorage.setItem(`notifications_${currentUserId}`, JSON.stringify(updatedNotifications));
    setNotifications(updatedNotifications);
    setUnreadCount(0);
  };

  const handleNotificationClick = (id) => {
    const currentUserId = localStorage.getItem('currentUserId');
    const updatedNotifications = notifications.map(notif => 
      notif.id === id ? { ...notif, read: true } : notif
    );
    
    localStorage.setItem(`notifications_${currentUserId}`, JSON.stringify(updatedNotifications));
    setNotifications(updatedNotifications);
    setUnreadCount(prev => Math.max(0, prev - 1));
  };

  const handleDeleteNotification = (id, e) => {
    e.stopPropagation();
    const currentUserId = localStorage.getItem('currentUserId');
    const updatedNotifications = notifications.filter(notif => notif.id !== id);
    
    localStorage.setItem(`notifications_${currentUserId}`, JSON.stringify(updatedNotifications));
    setNotifications(updatedNotifications);
    
    const unread = updatedNotifications.filter(n => !n.read).length;
    setUnreadCount(unread);
  };

  const handleClearAll = (e) => {
    e.stopPropagation();
    const currentUserId = localStorage.getItem('currentUserId');
    localStorage.setItem(`notifications_${currentUserId}`, JSON.stringify([]));
    setNotifications([]);
    setUnreadCount(0);
  };

  const getNotificationIcon = (type) => {
    switch (type) {
      case 'leave_approval':
      case 'leave_approved':
        return <FaCheckCircle className="HME-15 HME-16" />;
      case 'leave_rejected':
        return <FaExclamationCircle className="HME-15 HME-17" />;
      case 'project_assignment':
        return <FaClipboardList className="HME-15 HME-18" />;
      case 'expense_approval':
      case 'expense_approved':
        return <FaCheckCircle className="HME-15 HME-16" />;
      case 'expense_rejected':
        return <FaExclamationCircle className="HME-15 HME-17" />;
      case 'employee_update':
      case 'profile_updated_by_admin':
        return <FaUserEdit className="HME-15 HME-18" />;
      default:
        return <FaInfoCircle className="HME-15 HME-18" />;
    }
  };

  const getTimeAgo = (timestamp) => {
    const now = new Date();
    const notifTime = new Date(timestamp);
    const diffMs = now - notifTime;
    const diffMins = Math.floor(diffMs / 60000);
    const diffHours = Math.floor(diffMs / 3600000);
    const diffDays = Math.floor(diffMs / 86400000);

    if (diffMins < 1) return 'Just now';
    if (diffMins < 60) return `${diffMins} minute${diffMins > 1 ? 's' : ''} ago`;
    if (diffHours < 24) return `${diffHours} hour${diffHours > 1 ? 's' : ''} ago`;
    if (diffDays < 7) return `${diffDays} day${diffDays > 1 ? 's' : ''} ago`;
    return notifTime.toLocaleDateString();
  };

  const filteredNotifications = filterType === 'all' 
    ? notifications 
    : notifications.filter(n => n.type && n.type.toLowerCase().includes(filterType));

  const isClient = role === 'CLIENT';

  

  return (
    <div className="HME-00">
      <div className="HME-01">
        <div className="HME-02">
          <img 
            className="HME-03" 
            src="https://i.ibb.co/BHKCMXV8/Whats-App-Image-2025-06-16-at-11-21-26-AM.jpg" 
            alt="Logo" 
          />
        </div>
        
        <div className="HME-04">
          <div 
            className="HME-05"
            onClick={() => {
              setShowNotifications(!showNotifications);
              setShowProfileMenu(false);
            }}
          >
            <FaBell className="HME-06" />
            {unreadCount > 0 && (
              <span className="HME-07">{unreadCount}</span>
            )}
          </div>

          <div
            className="HME-08"
            onClick={() => {
              setShowProfileMenu(!showProfileMenu);
              setShowNotifications(false);
            }}
          >
            {profileImage ? (
              <img src={profileImage} alt="Profile" className="HME-09" />
            ) : (
              <FaUser className="HME-10" />
            )}
            <span className="HME-11">{userName}</span>
            {showProfileMenu && (
              <div className="HME-12" onClick={(e) => e.stopPropagation()}>
                <p onClick={handleViewProfile}>View Profile</p>
                <p onClick={handleLogout}>Logout</p>
              </div>
            )}
          </div>
        </div>
      </div>

      {showNotifications && (
        <div className="HME-13">
          <div className="HME-14">
            <h3>Notifications</h3>
            <button 
              className="HME-19"
              onClick={() => setShowNotifications(false)}
            >
              <FaTimes />
            </button>
          </div>

          <div className="HME-20">
            <button 
              className={`HME-21 ${filterType === 'all' ? 'active' : ''}`}
              onClick={() => setFilterType('all')}
            >
              All ({notifications.length})
            </button>
            <button 
              className={`HME-21 ${filterType === 'leave' ? 'active' : ''}`}
              onClick={() => setFilterType('leave')}
            >
              Leaves
            </button>
            <button 
              className={`HME-21 ${filterType === 'project' ? 'active' : ''}`}
              onClick={() => setFilterType('project')}
            >
              Projects
            </button>
            <button 
              className={`HME-21 ${filterType === 'employee' ? 'active' : ''}`}
              onClick={() => setFilterType('employee')}
            >
              Updates
            </button>
          </div>

          {notifications.length > 0 && (
            <div className="HME-22">
              {unreadCount > 0 && (
                <button 
                  className="HME-23"
                  onClick={handleMarkAllRead}
                >
                  Mark all as read
                </button>
              )}
              <button 
                className="HME-23 danger"
                onClick={handleClearAll}
              >
                Clear all
              </button>
            </div>
          )}

          <div className="HME-24">
            {filteredNotifications.length === 0 ? (
              <div className="HME-25">
                <FaBell className="HME-26" />
                <p>No notifications yet</p>
                <span>You'll see updates here</span>
              </div>
            ) : (
              filteredNotifications.map((notification) => (
                <div 
                  key={notification.id} 
                  className={`HME-27 ${notification.read ? 'read' : 'unread'}`}
                  onClick={() => handleNotificationClick(notification.id)}
                >
                  <div className="HME-28">
                    {getNotificationIcon(notification.type)}
                  </div>
                  
                  <div className="HME-29">
                    <p className="HME-30">{notification.message}</p>
                    
                    {notification.details && Object.keys(notification.details).length > 0 && (
                      <div className="HME-31">
                        {notification.details.approver && (
                          <span className="HME-32">By: {notification.details.approver}</span>
                        )}
                        {notification.details.updatedBy && (
                          <span className="HME-32">By: {notification.details.updatedBy}</span>
                        )}
                        {notification.details.employeeName && (
                          <span className="HME-32">Employee: {notification.details.employeeName}</span>
                        )}
                        {notification.details.project && (
                          <span className="HME-32">Project: {notification.details.project}</span>
                        )}
                        {notification.details.amount && (
                          <span className="HME-32">Amount: ₹{notification.details.amount}</span>
                        )}
                        {notification.details.reason && (
                          <span className="HME-32">Reason: {notification.details.reason}</span>
                        )}
                        {notification.details.changes && (
                          <span className="HME-32">Changed: {notification.details.changes}</span>
                        )}
                      </div>
                    )}
                    
                    <span className="HME-33">{getTimeAgo(notification.timestamp)}</span>
                  </div>

                  <button 
                    className="HME-34"
                    onClick={(e) => handleDeleteNotification(notification.id, e)}
                  >
                    <FaTimes />
                  </button>
                </div>
              ))
            )}
          </div>
        </div>
      )}

      {showProfileModal && (
        <div className="HME-35" onClick={() => setShowProfileModal(false)}>
          <div className="HME-36" onClick={(e) => e.stopPropagation()}>
            <button className="HME-37" onClick={() => setShowProfileModal(false)}>
              <FaTimes />
            </button>
            <div className="HME-38">
              <div className="HME-39">
                <h2>Profile Information</h2>
              </div>
              <div className="HME-40">
                <div className="HME-41">
                  {profileImage ? (
                    <img src={profileImage} alt="Profile" className="HME-42" />
                  ) : (
                    <div className="HME-43">
                      <FaUser />
                    </div>
                  )}
                </div>
                <div className="HME-44">
                  <div className="HME-45">
                    <label>Name:</label>
                    <p className="HME-46">{userName}</p>
                  </div>
                  <div className="HME-45">
                    <label>Email:</label>
                    <p className="HME-46">{userEmail || "Not provided"}</p>
                  </div>
                  <div className="HME-45">
                    <label>Role:</label>
                    <p className="HME-46">{userRole || "Client"}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      <div className="HME-47">
        <div className="HME-48">
          <div className="HME-49" style={{ transform: `translateX(-${currentSlide * 100}%)` }}>
            {carouselImages.map((image, index) => (
              <div key={index} className="HME-50">
                <img src={image} alt={`Slide ${index + 1}`} className="HME-51" />
              </div>
            ))}
          </div>

          <button onClick={goToPrevious} className="HME-52 HME-53">
            <FaChevronLeft size={20} />
          </button>

          <button onClick={goToNext} className="HME-52 HME-54">
            <FaChevronRight size={20} />
          </button>

          <div className="HME-55">
            {carouselImages.map((_, index) => (
              <button
                key={index}
                onClick={() => goToSlide(index)}
                className={`HME-56 ${currentSlide === index ? 'active' : ''}`}
                aria-label={`Go to slide ${index + 1}`}
              />
            ))}
          </div>
        </div>

        <div className="HME-57">
          {visibleCards.map((card) => {
            const IconComponent = card.Icon;
            return (
              <div 
                key={card.id} 
                className="HME-58"
                onClick={() => handleCardClick(card.id)}
                style={{ cursor: transitioning ? 'wait' : 'pointer' }}
              >
                <div className="HME-59">
                  <IconComponent />
                </div>
                <span className="HME-60">{card.text}</span>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Home;















